import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import IconButton from '@mui/material/IconButton';
import Tooltip, { TooltipProps } from 'atoms/Tooltip';
import cn from 'classnames';
import debounce from 'lodash/debounce';
import { observer } from 'mobx-react-lite';
import React, { ReactNode, useEffect, useState } from 'react';
import { useStore } from 'stores/store';
import { reportEvent } from 'utils/analytics';
import { navigateToAuthUrl } from 'utils/authUtils';

import s from './Watch.module.scss';

interface IWatch {
  watch?: boolean;
  activeIcon?: ReactNode;
  inactiveIcon?: ReactNode;
  offering_id?: string;
  children?: ReactNode;
  customClass?: string;
  isAuthenticated?: boolean;
  isApproved?: boolean;
  tooltipProps?: TooltipProps;
}

const Watch = ({
  watch,
  activeIcon = <StarIcon className={s.Watch__active} />,
  inactiveIcon = <StarBorderIcon />,
  offering_id,
  children,
  customClass,
  isAuthenticated,
  isApproved,
  tooltipProps
}: IWatch) => {
  const store = useStore();

  const [isWatch, setWatch] = useState<boolean>(watch || false);
  const [isHovered, setIsHovered] = useState<boolean>(false);

  useEffect(() => {
    setWatch(watch || false);
  }, [watch]);

  const onSignIn = () => {
    return navigateToAuthUrl({ isAuthenticated });
  };

  const onWatchList = () => {
    if (offering_id) {
      if (isApproved) {
        if (isWatch) {
          reportEvent('remove_watch', { offering_id: offering_id });
          store.ProfileStore.removeWatch(offering_id);
        } else {
          reportEvent('add_watch', { offering_id: offering_id });
          store.ProfileStore.addWatch(offering_id);
        }
        setWatch(!isWatch);
      } else {
        onSignIn();
      }
    }
  };

  const onHover = (val: boolean) =>
    debounce(() => {
      setIsHovered(val);
    }, 50);

  return (
    <Tooltip
      title={isWatch ? 'Remove offering from my watchlist' : 'Add offering to my watchlist'}
      placement="top"
      {...tooltipProps}
    >
      <div className={cn(s.Watch, customClass)}>
        <IconButton
          aria-label="Watch Offering"
          sx={{ '&:hover': { backgroundColor: 'transparent' } }}
          onMouseOver={onHover(true)}
          onMouseLeave={onHover(false)}
          onClick={(event) => {
            event.stopPropagation();
            onWatchList();
          }}
        >
          {isWatch || isHovered ? activeIcon : inactiveIcon}
          {children}
        </IconButton>
      </div>
    </Tooltip>
  );
};

export default observer(Watch);
